module.exports = __webpack_public_path__ + "img/contact-logo.39085c5c.png";